(() => {
  const date = document.querySelector('#visit-date');
  if (date) {
    const today = new Date();
    date.min = `${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,'0')}-${String(today.getDate()).padStart(2,'0')}`;
  }
  document.querySelector('#delivery-state')?.addEventListener('change', () => {
    const status = document.querySelector('[data-shipping-feedback]');
    status.textContent = document.querySelector('#delivery-state').value === 'other'
      ? 'Direct delivery is currently available only in California, Washington, D.C., and Virginia. Find a store or plan a visit.' : '';
  });
  document.querySelectorAll('[data-share-recipe]').forEach(button => button.addEventListener('click', async () => {
    const card = button.closest('.recipe-card');
    const url = new URL(location.href); url.hash = card.id;
    const title = card.querySelector('h3').textContent;
    let status = card.querySelector('.share-status');
    if (!status) { status = document.createElement('p'); status.className = 'share-status'; status.setAttribute('role','status'); button.after(status); }
    const ingredients = [...card.querySelectorAll('.recipe-ingredients li')].map(el => el.textContent).join('\n');
    const method = [...card.querySelectorAll('.recipe-method li')].map((el,i) => `${i+1}. ${el.textContent}`).join('\n');
    const text = `${title}\n\n${ingredients}\n\n${method}\n\nKARAHIYO Spirits · Enjoy responsibly.`;
    try {
      if (navigator.share) await navigator.share({title, text, url:url.href});
      else if (navigator.clipboard) { await navigator.clipboard.writeText(`${text}\n${url.href}`); status.textContent = 'Recipe copied. Ready to share.'; }
      else { status.textContent = url.href; }
    } catch (error) { if (error.name !== 'AbortError') status.textContent = url.href; }
  }));
})();

// One grounded product, with a steady, fast scenery cadence.
(() => {
  document.querySelectorAll('[data-occasion-showcase]').forEach(showcase => {
    const scenes = [...showcase.querySelectorAll('[data-occasion-scene]')];
    if (scenes.length < 2) return;
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const interval = 3000;
    let current = 0, timer = null, inView = false, hovered = false, focused = false;
    // The scene itself stays keyboard reachable, without an overlaid control.
    showcase.tabIndex = 0;
    const ready = scene => scene.complete && scene.naturalWidth > 0;
    const allowed = () => inView && !document.hidden && !motion.matches && !hovered && !focused;
    const stop = () => { clearTimeout(timer); timer = null; };
    const advance = () => {
      const next = scenes.map((_, offset) => (current + offset + 1) % scenes.length).find(index => index !== current && ready(scenes[index]));
      if (next === undefined) return false;
      scenes[current].classList.remove('is-active');
      scenes[next].classList.add('is-active');
      current = next;
      return true;
    };
    const schedule = () => {
      if (!allowed()) return;
      timer = setTimeout(() => {
        timer = null;
        if (!allowed()) return;
        advance();
        schedule();
      }, interval);
    };
    const sync = () => { stop(); schedule(); };
    showcase.addEventListener('pointerenter', event => {
      if (event.pointerType === 'mouse' || event.pointerType === 'pen') { hovered = true; sync(); }
    });
    showcase.addEventListener('pointerleave', () => { hovered = false; sync(); });
    showcase.addEventListener('focusin', () => { focused = true; sync(); });
    showcase.addEventListener('focusout', event => { focused = showcase.contains(event.relatedTarget); sync(); });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        inView = entries.some(entry => entry.isIntersecting);
        sync();
      }, {threshold: .2});
      observer.observe(showcase);
    } else { inView = true; sync(); }
    document.addEventListener('visibilitychange', sync);
    motion.addEventListener('change', sync);
    scenes.forEach(scene => scene.addEventListener('load', sync, {once: true}));
    window.addEventListener('pagehide', stop);
    window.addEventListener('pageshow', sync);
  });
})();

(()=>{const translate=s=>window.KarahiyoLanguage?.translate(s)||s;for(const form of document.querySelectorAll('form')){form.addEventListener('invalid',event=>{const input=event.target;if(!input.matches('input,select,textarea'))return;event.preventDefault();const id=(input.id||input.name.replace(/[^a-z0-9]/gi,'-'))+'-error';let error=document.getElementById(id);if(!error){error=document.createElement('p');error.id=id;error.className='k-field-error';error.setAttribute('role','alert');input.after(error);}const msg=input.validity.valueMissing?'Please complete this field.':input.validity.typeMismatch&&input.type==='email'?'Please enter a valid email address.':'Please check this value.';error.textContent=translate(msg);input.setAttribute('aria-invalid','true');const described=new Set((input.getAttribute('aria-describedby')||'').split(' ').filter(Boolean));described.add(id);input.setAttribute('aria-describedby',[...described].join(' '));if(form.querySelector(':invalid')===input)input.focus();},true);form.addEventListener('input',event=>{const input=event.target;if(input.getAttribute('aria-invalid')==='true'){input.removeAttribute('aria-invalid');for(const id of (input.getAttribute('aria-describedby')||'').split(' ')){const e=document.getElementById(id);if(e?.classList.contains('k-field-error')){e.remove();input.setAttribute('aria-describedby',(input.getAttribute('aria-describedby')||'').split(' ').filter(x=>x!==id).join(' '));}}}});}})();

